<template>
    <div>
        <b-field class="commonrules-grp" label="The class of service  is "></b-field>
        <div class="airclasscheckbox" v-for="(res,i) in arr" :key="i">
            <b-checkbox type="is-teal"  @input="classOfServices(res)"  v-model="res.isSelected"><p>{{res.value}}</p></b-checkbox>
           
        </div>
    </div>
</template>
<script>
import { watch } from 'fs';

export default {
    name : "AirClassOfService",
    props:{ classOfSer : null },
    data(){
        return{
            classOfService : this.classOfSer?this.classOfSer:[],
            arr : [{
                    key:'Y',
                    value:'Economy',
                    isSelected:false
                },{
                    key:'M',
                    value:'Standard Economy',
                    isSelected:false
                },{
                    key:'W',
                    value:'Premium Economy',
                    isSelected:false
                },{
                    key:'C',
                    value:'Business',
                    isSelected:false
                },{
                    key:'F',
                    value:'First',
                    isSelected:false
                }]
        }
    },
    mounted(){
        for(const option of this.$data.arr){
            option.isSelected =  this.isChecked(option)
        }

    },
    methods : {
        classOfServices(val) {
            console.log(this.selectedServicesOptions)
          //  this.classOfService.push(val.key);
            // this.$emit('classOfServices',this.$data.classOfService);
            this.$emit('classOfServices',this.selectedServicesOptions);
        },
        isChecked(option){
            if(Array.isArray(this.$props.classOfSer)){
              return   this.$props.classOfSer.filter(_row => {
                   return ((option.key == _row.key && option.value == _row.value  )||option.key==_row)

                }).length > 0

            }
            return false
        }
    },
    computed: {
     
        selectedServicesOptions(){
         
            return this.$data.arr.filter(x => x.isSelected)
        }

    }
}
</script>